import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppButtonComponent } from '../../../app-button/app-button.component';
import { ButtonTypeEnum } from '../../../../enums/buttonType.enum';
import { NavigationSetup } from '../../../../services/navigation-items-service/navigation-setup';

@Component({
  selector: 'authentication-error-page',
  imports: [AppButtonComponent],
  templateUrl: './authentication-error-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './authentication-error-page.component.scss',
})
export class AuthenticationErrorPageComponent {
  constructor() {}

  protected refresh() {
    window.location.replace('/');
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly NavigationSetup = NavigationSetup;
}
